// Instagram never exposes true reach (unique accounts) on any scrapeable surface —
// it only exists in Meta's authenticated Insights API, visible solely to the
// account owner. SocialData (our data source) mirrors the public post-info surface,
// so reach can't be fetched for arbitrary third-party influencers.
//
// This is a heuristic estimate instead: reels are typically re-watched ~1.4-1.8x
// per unique viewer (loops, replays), so reach ≈ plays / ~1.5. Single ratio kept
// here so the Dashboard KPI card and the Influencers table column always agree.
export const REACH_ESTIMATE_RATIO = 0.65;

export function estimateReach(views) {
    const v = Number(views) || 0;
    return Math.round(v * REACH_ESTIMATE_RATIO);
}
